// removed by extract-text-webpack-plugin
module.exports = {"li":"small-area-module__li___36vB5","name":"small-area-module__name___1ySHK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/small-area-list/small-area.module.scss
// module id = 691
// module chunks = 0 1